export default __webpack_public_path__ + "static/media/arena-detalle.0efdcffe.png";